/**
 * The player editor's inputs are `type="search"`, and this keeps Esc doing what it did on a text field (#154).
 *
 * They are search fields only because Edge's "Saved info" does not offer an address into one — `autocomplete="off"`
 * and an unrecognised token both left it offering the desk's own details into a customer's record. A search field
 * clears itself when Esc is pressed with text in it, in the browser's default handler, which a text field never did:
 * an operator pressing Esc in the dialog would lose what they had typed. Cancelling the default stops exactly that.
 *
 * Propagation is left alone on purpose, so anything listening for Esc further up still hears it.
 */
export function keepTextOnEscape(event: { key: string; preventDefault(): void }): void {
  if (event.key === 'Escape') event.preventDefault();
}
